import { shimmer, svgToBase64 } from '@sohanscript/lib/utils';

export const shimmerPlaceholder =
	`data:image/svg+xml;base64,${svgToBase64(shimmer(700, 400))}` as const;

export const preloadedImages = new Set<string>();

export const cacheKey = (url: string) => url.split('?')[0];

export function preloadImage(...urls: string[]) {
	for (const url of urls) {
		if (preloadedImages.has(url)) continue;
		const img = new window.Image();
		img.src = url;
		const finish = () => preloadedImages.add(cacheKey(url));
		img.onload = finish;
		img.onerror = finish;
	}
}
